import React from 'react';

import Message from './Message';
import Timer from './Timer';

interface Props {
  deckClassName: string,
  imageClassName: string,
  imageSrc: string,
  onClick: () => any,
}

export default function DeckComponent({
  deckClassName,
  imageClassName,
  imageSrc,
  onClick,
}: Props) {
  return (
    <div className="deck-container">
      <button
        className={deckClassName}
        onClick={onClick}
        tabIndex={-1}
        type="button"
      >
        <img
          alt="Opportunity deck"
          className={imageClassName}
          src={imageSrc}
        />
      </button>
      <div className="deck-info">
        <div className="deck-info__cards-in-deck">
          <Message />
        </div>
        <div className="deck-info__timer">
          <Timer />
        </div>
      </div>
    </div>
  );
}

DeckComponent.displayName = 'DeckComponent';
